<template>
  <div class="cargoStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <div class="custom-date">
            <div class="date-btn1" @click="showStartDate">
              <span v-if="searchForm.BeginTime">{{
                searchForm.BeginTime
              }}</span>
              <span v-else>{{ $t.meta.beginDate }}</span>
            </div>
            <div class="date-btn2" @click="showEndDate">
              <span v-if="searchForm.EndTime">{{ searchForm.EndTime }}</span>
              <span v-else>{{ $t.meta.endDate }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-form>
      <ve-pie :data="chartData"></ve-pie>

      <div class="cargoStatistics-radio">
        <div class="radio-label">
          {{ $t.cargoStatistics.totalProfit }}：{{ settlementCurrency }}
          {{ totalProfit }}
        </div>
        <van-radio-group v-model="searchForm.Type" @change="getList">
          <van-radio
            :name="index + 1"
            v-for="(item, index) in chartData.rows"
            :key="index"
            >{{ item.type }}：{{ settlementCurrency }}
            {{ item.value }}</van-radio
          >
        </van-radio-group>
      </div>
    </van-form>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item.CityId)"
      >
        <div class="list-item">
          {{ $t.cargoStatistics.country }}：{{ item.CountryName }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.destinationCity }}：{{ item.Code }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.jobs }}：{{ item.TotalVotes }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.totalValue }}：{{ item.TotalVolume }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.totalWeight }}：{{ item.TotalWeight }}
        </div>
        <div class="list-item">20'：{{ item.Degrees20 }}</div>
        <div class="list-item">40'：{{ item.Degrees40 }}</div>
        <div class="list-item">40'HQ：{{ item.Degrees40HQ }}</div>
        <div class="list-item">Others：{{ item.Others }}</div>
        <div class="list-item">
          {{ $t.cargoStatistics.totalCost }}：{{ item.TotalCost }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.totalSell }}：{{ item.TotalSelling }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.totalProfit }}：{{ item.TotalProfitAmount }}
        </div>
        <div class="list-item">
          {{ $t.cargoStatistics.profitPercent }}：{{ item.ProfitPercentage }}
        </div>
      </div>
    </van-list>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";

import {
  List,
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Row,
  Col,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(List)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "cargoStatistics",
  data() {
    return {
      searchForm: {
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        BeginTime: "",
        EndTime: "",
        Type: 1,
      },
      totalProfit: "",
      settlementCurrency: "",
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      showEndPicker: false,
      chartData: null,
    };
  },
  created() {
    this.initChartData();
    this.defaultDate();
    this.cargoStatistics();
  },
  methods: {
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "lineChartStatistics",
        name: "lineChartStatistics",
        query: [
          {
            name: "CityId",
            value: id,
          },
          {
            name: "SelectType",
            value: this.searchForm.Type,
          },
        ],
      });
    },
    initChartData() {
      this.chartData = {
        columns: ["type", "value"],
        rows: [],
      };
    },
    onSearch() {
      this.initChartData();
      this.cargoStatistics();
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.searchForm.BeginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.searchForm.EndTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.searchForm.BeginTime = beg;
      this.searchForm.EndTime = end;
    },
    cargoStatistics() {
      this.$commonMethod.showLoading();
      var param = this.searchForm;
      this.$api.dataSummary
        .cargoStatistics(param)
        .then((res) => {
          var data = res.data;
          this.totalProfit = data.TotalProfit;
          this.settlementCurrency = data.SettlementCurrency;
          var rows = [];
          for (var item of data.ProfitType) {
            var type = "";
            if (item.WB_Type == 1) {
              type = this.$t.meta.wbType1;
            }
            if (item.WB_Type == 2) {
              type = this.$t.meta.wbType2;
            }
            if (item.WB_Type == 3) {
              type = this.$t.meta.wbType3;
            }
            if (item.WB_Type == 4) {
              type = this.$t.meta.wbType4;
            }
            if (item.WB_Type == 5) {
              type = this.$t.meta.wbType5;
            }
            rows.push({
              type: type,
              value: item.ProfitAmount,
            });
          }
          this.chartData.rows = rows;
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];

      var param = this.searchForm;
      this.$api.dataSummary
        .getStatisticalDetailsList(param)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.cargoStatistics {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 42%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 42%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
            width: 15%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .van-form {
    .ve-pie {
      padding: 20px 0px;
    }
    .cargoStatistics-radio {
      padding-top: 0px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebedf0;
      .radio-label {
        color: #000;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .van-radio {
        margin-bottom: 10px;
        font-size: 12px;
        ::v-deep .van-radio__label {
          color: #646566;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        width: 50%;
        display: inline-block;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
